import React, {Component, useState, useContext, useEffect} from 'react';
import ReactDOM from 'react-dom';
import { Layout } from '../../../layouts';
import Welcome from '../../../layouts/welcome';
import Row from '../../../components/row';
import { ButtonCancel, ButtonModify, ButtonRemove, ButtonReturn, ButtonSave } from '../../../components/buttons';
import Container from '../../../layouts/containers/container';
import TabBar from '../components/tab-bar';
import companiesApi from '../../../lib/companies/companies-api';
import List from '../../../components/list';
import membershipsApi from '../../../lib/memberships/memberships-api';
import ContainerGrid from '../../../layouts/containers/container-grid';
import ArrowRight from '../../../icons/arrow-right';
import { stringToFriendlyDatetime } from '../../../lib/helpers/datetime-helpers';
import PopupContext from '../../../context/context-popup';
import PopupsCancelMembership from '../popups/popups-cancel-membership';
import Grid from '../../../components/grid';
import Stats from '../../../components/stats';
import CompanyCredits from '../../../icons/company-credits';
import LabelContainer from '../../../components/label-container';
import dayjs from 'dayjs';
import { SmallPill } from '../../../components/pills';
import { FormatMonths } from '../../../lib/helpers';

const PurchasedMembership = (props) => {
    const { membership, purchased, ends } = props;

    return (
        <div class="membership" style={{
            maxWidth: '500px'
        }}>
            <div class="membership__top">
                <div class="membership__image">
                    <div class="membership-image__overlay"></div>
                </div>
                <div className="membership__details">
                    <div class="membership__name">{ membership?.name }</div>
                    <div class="membership__price">£{ membership?.monthly_price } <span>every</span> { FormatMonths(membership?.renewal_interval_month) }</div>
                </div>
            </div>
            <div class="membership__information">
                { membership?.content?.features?.map((feature, index) => {
                    return <div key={index} className="membership-information__item">{ feature?.name }</div>
                })}
            </div>
            <button class="membership__purchase">
                Purchased at { stringToFriendlyDatetime(purchased) }
                { ends !== null && ` - Will Expire On: ${stringToFriendlyDatetime(ends)}` }
            </button>
        </div>
    )
}

const Membership = (props) => {
    const { membership } = props;

    return (
        <div class="membership">
            <div class="membership__top">
                <div class="membership__image">
                    <div class="membership-image__overlay"></div>
                </div>
                <div className="membership__details">
                    <div class="membership__name">{ membership?.name }</div>
                    <div class="membership__price">£{ membership?.monthly_price } <span>every</span> { FormatMonths(membership?.renewal_interval_month) }</div>
                </div>
            </div>
            <div class="membership__information">
                { membership?.content?.features?.map((feature, index) => {
                    return <div key={index} className="membership-information__item">{ feature?.name }</div>
                })}
            </div>
            <button class="membership__purchase" onClick={() => window.location.href = `/mydmc/account/memberships/${membership.id}`}>Purchase <ArrowRight/></button>
        </div>
    )
}

const MembershipPlan = (props) => {
    const { plan, membership, created_at, getMemberships, company, credits } = props;
    const { setPopup } = useContext(PopupContext);
    const [ modifying, setModifying ] = useState(false);

    const creditsThisMonth = credits?.year?.[dayjs().startOf('month').format('YYYY-MM-DD')];

    const cancelMembership = () => {
        setPopup(<PopupsCancelMembership membership={membership} company={company} onSuccess={getMemberships} getMemberships={getMemberships}/>);
    }

    const Buttons = () => {
        if (membership?.public === 1) {
            return <>
                 <ButtonModify onClick={() => window.location.href = `/mydmc/account/memberships/${membership?.id}/view`}>See Current Plan</ButtonModify>
                { !modifying && <ButtonModify color="orange" onClick={() => setModifying(true)}>Change</ButtonModify> }
                { plan?.ends === null && <ButtonRemove onClick={cancelMembership}>Cancel</ButtonRemove> }
            </>
        }

        return <ButtonModify onClick={() => window.location.href = `/mydmc/messages`}>Contact Us</ButtonModify>
    }

    return (
        <Container>
            <Container.Header>
                <Row gap="20px" wrap justifyContent="space-between">
                    <Container.Text fontSize="30px" color="#FF6933">{ membership?.name }</Container.Text>

                    <Row gap="20px">
                        { !modifying && <Buttons/> }
                    </Row>
                </Row>
            </Container.Header>

            <Container.Content>
                { !modifying && <div className="booking-view">
                    <LabelContainer label={<Container.Text fontSize="14px" color="#FF6933">What's Included</Container.Text>} className="booking-view__child">
                        <PurchasedMembership 
                            membership={membership}
                            purchased={created_at}
                            ends={plan?.ends}
                        />
                    </LabelContainer>

                    <List gap="40px" className="booking-view__child">
                        <Row wrap gap="60px">
                            <LabelContainer label={<Container.Text fontSize="14px" color="#FF6933">Plan Registered To</Container.Text>} style={{ flex: 1 }}>
                                { company?.name }
                            </LabelContainer>
                            
                           { plan?.ends !== null && <LabelContainer label={<Container.Text fontSize="14px" color="#FF6933">Plans Ends</Container.Text>} style={{ flex: 1 }}>
                                { stringToFriendlyDatetime(plan?.ends) }
                            </LabelContainer> }
                        </Row>

                        <LabelContainer label={<Container.Text fontSize="14px" color="#FF6933">Your Companies Current Usage</Container.Text>}>
                            <List gap="20px">
                                <div className="banner">
                                    <Container className="banner__item banner__credits">
                                        <Container.Header>
                                            <Row gap="20px" justifyContent="space-between">
                                                <Row gap='10px'>
                                                    <Container.Icon src={CompanyCredits}/>
                                                    <Container.Text fontSize="20px" color="white" fontWeight='500'>Your Membership Credits</Container.Text>
                                                </Row>
                                                <SmallPill onClick={() => window.location.href = `/mydmc/account/memberships/debits`}>See More</SmallPill>
                                            </Row>
                                        </Container.Header>

                                        <Container.Content>
                                            <Row gap="40px">
                                                <Stats center valueColor="white" titleColor="#00C8C3" title="Used this month" value={Number.parseInt(membership?.credits_per_month - creditsThisMonth)}/>
                                                <Stats center valueColor="white" titleColor="#00C8C3" title="Remaining (Current Month)" value={creditsThisMonth} />
                                            </Row>
                                        </Container.Content>
                                    </Container>
                                </div>

                                { credits?.additional_credits > 0 && <div className="banner">
                                    <Container className="banner__item banner--orange">
                                        <Container.Header>
                                            <Row gap="20px" justifyContent="space-between">
                                                <Row gap='10px'>
                                                    <Container.Icon src={CompanyCredits}/>
                                                    <Container.Text fontSize="20px" color="white" fontWeight='500'>Additional Credits</Container.Text>
                                                </Row>
                                                <SmallPill onClick={() => window.location.href = `/mydmc/account/memberships/debits`}>See More</SmallPill>
                                            </Row>
                                        </Container.Header>

                                        <Container.Content>
                                            <Row gap="40px">
                                                <Stats center valueColor="white" titleColor="#00C8C3" title="Remaining" value={credits?.additional_credits} />
                                            </Row>
                                        </Container.Content>
                                    </Container>
                                </div> }

                            </List>
                        </LabelContainer>
                    </List>
                </div> }

                { modifying && <ChoosePlan company={company}/> }
            </Container.Content>
        </Container>
    )
}

const ChoosePlan = ({ membership = null, company }) => {
    const [ availableMemberships, setAvailableMemberships ] = useState([]);

    useEffect(() => {
        companiesApi.getAvailableMemberships(company?.id).then(({ data }) => setAvailableMemberships(data));
    }, []);

    return (
        <Container>
            <Container.Header>
                <Container.Text fontSize="30px" color="#FF6933">Add a Membership plan to your Company</Container.Text>
            </Container.Header>

            <Container.Content>
                <ContainerGrid>
                    { availableMemberships?.map(membership => <Membership membership={membership}/>) }
                </ContainerGrid>
            </Container.Content>
        </Container>
    )
}

class Memberships extends Component {
    static contextType = PopupContext;

    constructor() {
        super();

        this.state = {
            company: null,
        }
    }

    async componentDidMount() {
        this.getCompany();
        this.getCreditsUsage()
    }

    async getCompany() {
        const data = await companiesApi.getCompany(window.user?.company_id);

        this.setState({ company: data?.data });
    }

    async getCreditsUsage() {
        const data = await companiesApi.getCreditsUsage(window.user?.company_id);

        this.setState({ credits: data?.data });
    }

    render() {
        if (this.state.company === null) return null;

        return (
            <Layout 
                theme="light"
                topLeft={
                    <Welcome 
                        title={<Container.Text fontSize="18px" color="#FF6933">Manage</Container.Text>}
                        subtitle="My Memberships"
                    />
                }
                topRight={
                    <Row gap="20px">
                        <ButtonSave>Save</ButtonSave>
                    </Row>
                }
            >
                <List gap="40px">
                    <TabBar active={4}/>

                    <List gap="40px">
                        { this.state.company?.company_memberships?.length > 0 ? 
                            this.state.company?.company_memberships?.map((plan, index) => {
                                const { membership, created_at } = plan;

                                return <MembershipPlan 
                                    key={index} 
                                    plan={plan}
                                    membership={membership} 
                                    created_at={created_at}
                                    getMemberships={this.getCompany.bind(this)}
                                    company={this.state.company}
                                    credits={this.state.credits}
                                />
                            }) 
                            :
                            <ChoosePlan company={this.state.company}/>
                        }
                    </List>
                </List>
            </Layout> 
        )
    }
}

const el = document.getElementById('account-memberships');

if (el) {
    ReactDOM.render(<Memberships/>, el);
}
